import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=4186c8b6&scoped=true&"
import script from "./recycle.vue?vue&type=script&lang=ts&"
export * from "./recycle.vue?vue&type=script&lang=ts&"
import style0 from "./recycle.vue?vue&type=style&index=0&id=4186c8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186c8b6",
  null
  
)

export default component.exports